var _rect, _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6340_380353)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#F0F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.667 116V124C120.667 134.667 136 139.333 136 139.333C136 139.333 118.333 152.667 100 152.667C81.6667 152.667 64 139.333 64 139.333C64 139.333 79.454 134.667 79.3333 124C79.2127 113.333 79.2933 107.067 79.2127 88.7919C69.658 76.4073 70.2713 68.0953 75.496 62.2499C93 42.6666 140.667 49.3333 140.667 49.3333C140.667 49.3333 145.115 97.3286 135 111.333C130.667 117.333 120.667 116 120.667 116Z",
    fill: "url(#paint0_linear_6340_380353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.667 116C106 114.333 97.3333 108 97.3333 108C102.805 116.095 111.144 121.813 120.667 124V116Z",
    fill: "#DB6F3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 159.539C176.347 172.443 180 202.205 180 202.205H20C20 202.205 23.6547 172.44 30 159.539C36.3453 146.637 73.4 134.671 73.4 134.671C80.542 149.333 119.739 149.333 126.581 134.667C126.581 134.667 163.653 146.634 170 159.539Z",
    fill: "#B2BEC3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6340_380353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 134,
    width: 160,
    height: 69
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 159.539C176.347 172.443 180 202.205 180 202.205H20C20 202.205 23.6547 172.44 30 159.539C36.3453 146.637 73.4 134.671 73.4 134.671C80.542 149.333 119.739 149.333 126.581 134.667C126.581 134.667 163.653 146.634 170 159.539Z",
    fill: "#DFE6E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6340_380353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 192V186.667H186.667V192H13.3333ZM13.3333 178.667V173.333H186.667V178.667H13.3333ZM13.3333 165.333V160H186.667V165.333H13.3333Z",
    fill: "#DFE6E9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4367 68.8059C85.3167 66.9853 82.7407 65.7593 79.0993 67.6513C70.4667 72.1333 77 89.3333 84.6667 89.3333C86.6667 89.3333 87.6613 95.6146 78.7567 99.9999C78.7567 92.9999 68.09 75.6666 67.1567 59.8853C56.4233 55.8886 59.09 39.8973 66.4587 39.8973C65.2827 25.2386 88.7567 17.6666 97.846 26.0793C107.09 14.9999 130.423 20.6666 131.832 30.2786C147.877 21.7139 158.423 46.3333 143.4 55.8906C137.218 59.8239 122.757 61.3206 101.881 61.3206C98.73 61.3206 96.9647 62.1033 97.846 65.9999C99.552 73.5506 95.5913 78.3066 87.4367 68.8059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6340_380353",
    x1: 102.82,
    y1: 48.2394,
    x2: 102.82,
    y2: 152.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6340_380353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser14);
export default __webpack_public_path__ + "static/media/user-14.9b86f2f11aa78fd9d3635ec699d43c2e.svg";
export { ForwardRef as ReactComponent };